<template>
  <div class="form-container narrow">
    <div class="form-header">
      <h2>Change Password</h2>
    </div>
    <form @submit.prevent="handleSubmit" class="form">
      <div class="form-section">
        <div class="form-group">
          <label for="currentPassword" class="required">Current Password</label>
          <input
            type="password"
            id="currentPassword"
            v-model="formData.currentPassword"
            class="form-control"
            required
          />
        </div>

        <div class="form-group">
          <label for="newPassword" class="required">New Password</label>
          <input
            type="password"
            id="newPassword"
            v-model="formData.newPassword"
            class="form-control"
            required
          />
          <div class="field-details">
            Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character.
          </div>
        </div>

        <div class="form-group">
          <label for="confirmPassword" class="required">Confirm New Password</label>
          <input
            type="password"
            id="confirmPassword"
            v-model="formData.confirmPassword"
            class="form-control"
            required
          />
        </div>
      </div>

      <div class="error-message" v-if="error">
        Password was not changed:<br>
        {{ error }}
      </div>
      <div class="success-message" v-if="success">
        Password has been changed successfully!
      </div>

      <div class="form-actions horizontal">
        <button type="submit" class="submit-button big" :disabled="loading">
          {{ loading ? 'Changing...' : 'Change Password' }}
        </button>
        <button type="button" class="cancel-button medium" @click="handleCancel">
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { changePassword } from '@/scripts/services/authService';
import { validatePassword } from '@/scripts/shared-utils';

const router = useRouter();
const error = ref('');
const success = ref(false);
const loading = ref(false);

const formData = ref({
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
});

const handleSubmit = async () => {
  error.value = '';
  
  if (formData.value.newPassword !== formData.value.confirmPassword) {
    error.value = 'New passwords do not match';
    return;
  }

  if (formData.value.currentPassword === formData.value.newPassword) {
    error.value = 'New password must be different from current password';
    return;
  }

  const validation = validatePassword(formData.value.newPassword);
  if (!validation.success) {
    error.value = validation.error;
    return;
  }

  loading.value = true;
  const result = await changePassword(formData.value.currentPassword, formData.value.newPassword);
  formData.value = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  success.value = (result === true);
  if (success.value) {  
    setTimeout(() => {
      closeForm();
    }, 3000);
  } else {
    error.value = result;
  }
  loading.value = false;
};

const handleCancel = () => {
  router.back();
};

const closeForm = () => {
  router.push('/users/me/edit');
};
</script>

<style scoped>
@import '../styles/shared-form.css';
</style>
